export const formatEdamaUnit = (unit: string) => {
  return `${unit}(s)`
}

export const formatUnit = (unit: string, isEdama: boolean) => {
  return isEdama ? formatEdamaUnit(unit) : unit
}

export const capitalizeFirstLetter = (name?: string) => {
  if (!name) return ""

  return name.charAt(0).toUpperCase() + name.slice(1)
}

export function formatGender(gender: string) {
  if (!gender) return ""

  const lowercase = gender.toLowerCase()
  return capitalizeFirstLetter(lowercase)
}

export const formatInputtingFoodName = (name: string) => {
  const isInputtingFirstLetter = name.length === 1
  return isInputtingFirstLetter ? capitalizeFirstLetter(name) : name
}
